import raterJs from 'rater-js';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.initializeRating();
  }

  initializeRating() {
    const averageRating = parseFloat(this.element.dataset.averageRating);

    raterJs({
      element: this.element,
      max: 5,
      rating: averageRating,
      readOnly: true,
      starSize: 16,
      step: 0.5,
      ratedFill: '#f5a623',
      unfilledColor: '#ccc',
    });

    // rater-js renders the stars as background-image spans with only a `title`
    // tooltip — assistive tech gets no meaningful value. Expose the read-only
    // rating as a single labelled image so it is announced (WCAG 1.1.1 / 4.1.2).
    if (!Number.isNaN(averageRating)) {
      const rounded = Math.round(averageRating * 10) / 10;
      this.element.setAttribute('role', 'img');
      this.element.setAttribute('aria-label', `Rated ${rounded} out of 5 stars`);
    }
  }
}
